import { render, staticRenderFns } from "./BtnInserirAnexoMedicao.vue?vue&type=template&id=00df8b94&"
import script from "./BtnInserirAnexoMedicao.vue?vue&type=script&lang=js&"
export * from "./BtnInserirAnexoMedicao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports